import { render, staticRenderFns } from "./AlarmDeal.vue?vue&type=template&id=21d84b68&scoped=true&"
import script from "./AlarmDeal.vue?vue&type=script&lang=js&"
export * from "./AlarmDeal.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDeal.vue?vue&type=style&index=0&id=21d84b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d84b68",
  null
  
)

export default component.exports